import React from 'react';
import styled from '@emotion/styled';
import { isPresent } from '@seedlang/utils';
import { AppUI } from '@seedlang/state';
import EpisodeCode from 'components/episode_code';

const Wrapper = styled.div`
  aspect-ratio: 242 / 140;
  background: white;
  border: ${props => props.border};
  border-radius: ${props => props.borderRadius};
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 42% 1fr;
  overflow: hidden;
  position: relative;
  width: 100%;

  &::before {
    background: ${props => props.accentColorWithStrongOpacity};
    clip-path: polygon(0 0, 100% 100%, 0 100%);
    content: '';
    inset: 40px 100px 0 0;
    position: absolute;
  }

  &.grayscale {
    filter: gray;
    filter: grayscale(1);
    transition: filter 0.3s ease;

    &:hover {
      filter: none;
    }
  }
`;

const ThumbnailImage = styled.img`
  border: ${props => props.border};
  border-radius: ${props => props.borderRadius};
  box-sizing: border-box;
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

const CoverWrapper = styled.div`
  align-items: center;
  background: transparent;
  display: flex;
  justify-content: center;
  margin-left: 20px;
  min-width: 0;
  padding: 10px;
  position: relative;
  z-index: 1;
`;

const CoverImage = styled.img`
  border-radius: 8px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.24);
  display: block;
  max-height: 100%;
  max-width: 100%;
`;

const TextWrapper = styled.div`
  align-items: flex-start;
  color: #222;
  display: flex;
  flex-direction: column;
  height: 70%;
  justify-content: flex-end;
  margin-left: 10px;
  min-width: 0;
  padding: 12px;
  position: relative;
  z-index: 1;
`;

const EpisodeCodeWrapper = styled.div`
  color: #666;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 16px;
  margin-bottom: 6px;
`;

const Title = styled.div`
  display: -webkit-box;
  font-size: ${props => props.fontSize};
  font-weight: 800;
  line-clamp: 3;
  line-height: 1.15;
  overflow: hidden;
  overflow-wrap: anywhere;
  text-align: start;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-word;
`;

const hqImageUrl = url => {
  if (!url || typeof url !== 'string') return url;
  return url.replace('maxres', 'hq');
};

const titleFontSize = title => {
  if (!title) return '18px';
  if (title.length > 55) return '14px';
  if (title.length > 40) return '15px';
  if (title.length > 28) return '16px';
  return '18px';
};

const accentColorWithStrongOpacity = accentColor => {
  if (!accentColor) return '#000000CC';
  if (/^#[0-9a-fA-F]{6}$/.test(accentColor)) return `${accentColor}CC`;
  if (/^#[0-9a-fA-F]{3}$/.test(accentColor)) {
    const [, r, g, b] = accentColor;
    return `#${r}${r}${g}${g}${b}${b}CC`;
  }
  return accentColor;
};

class PodcastEpisodeThumbnail extends React.Component {
  static defaultProps = {
    border: 'none',
    borderRadius: '10px',
  };

  render() {
    const { worksheet } = this.props;

    if (!worksheet) {
      return null;
    }

    if (isPresent(worksheet.imageUrl)) {
      return (
        <ThumbnailImage
          alt={worksheet.name}
          border={this.props.border}
          borderRadius={this.props.borderRadius}
          className={this.props.className}
          src={hqImageUrl(worksheet.imageUrl)}
        />
      );
    }

    return (
      <Wrapper
        accentColor={AppUI.site.accentColor}
        accentColorWithStrongOpacity={accentColorWithStrongOpacity(AppUI.site.accentColor)}
        border={this.props.border}
        borderRadius={this.props.borderRadius}
        className={this.props.className}
      >
        <CoverWrapper>
          {
            isPresent(worksheet.podcastEpisode?.imageUrl) &&
              <CoverImage
                alt=''
                src={worksheet.podcastEpisode.imageUrl}
              />
          }
        </CoverWrapper>
        <TextWrapper>
          <EpisodeCodeWrapper>
            Episode <EpisodeCode episodeCode={worksheet.episodeCode} />
          </EpisodeCodeWrapper>
          <Title fontSize={titleFontSize(worksheet.name)}>{worksheet.name}</Title>
        </TextWrapper>
      </Wrapper>
    );
  }
}

export default PodcastEpisodeThumbnail;
